import { PRIVATE } from '@/plugins/acl/const'
import comingSoonRoute from '@/router/utils/comingSoonRoute'

const logistics = [
  {
    path: '/logistics/apartments',
    name: 'logistics-apartments-list',
    component: () => import('@/views/logistics/apartments/house-list/HouseList.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.STAFF.HOUSES,
    },
  },
  {
    path: '/logistics/apartments/:id',
    name: 'logistics-apartments-view',
    component: () => import('@/views/logistics/apartments/house-view/HouseView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.STAFF.HOUSES,
      breadCrumb(context) {
        return [
          {
            text: 'apartments',
            useI18n: true,
            to: { name: 'logistics-apartments-list' },
          },
          {
            text: context.houseName,
            useI18n: false,
          },
        ]
      },
    },
  },
  {
    path: '/logistics/apartments/room/:id',
    name: 'logistics-apartments-room-view',
    component: () => import('@/views/logistics/apartments/house-view/house-room-view/RoomView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.STAFF.HOUSES,
      breadCrumb(context) {
        return [
          {
            text: 'apartments',
            useI18n: true,
            to: { name: 'logistics-apartments-list' },
          },
          {
            text: context.houseName,
            useI18n: false,
            to: {
              name: 'logistics-apartments-view',
              params: {
                id: context.houseId,
              },
            },
          },
          {
            text: context.roomName,
            useI18n: false,
          },
        ]
      },
    },
  },
  comingSoonRoute({
    path: '/logistics/fleet',
    name: 'logistics-fleet',
    comingSoonKey: 'logisticsFleet',
    resource: PRIVATE.LOGISTICS.FLEET,
  }),
  comingSoonRoute({
    path: '/logistics/resources',
    name: 'logistics-resources',
    comingSoonKey: 'logisticsResources',
    resource: PRIVATE.LOGISTICS.RESOURCES,
  }),
]

export default logistics
